const parseDepartureData = (departuresIatas, flights) => {
  const tempDepartureData = departuresIatas
    .map((departure) => {
      if (!flights[departure] || !flights[departure].length) {
        return null;
      }
      const data = {
        comment: '', // TODO: Add comment field
        lowest_price: 9999999,
        provider_permalink: '',
        departure_iata: departure,
        destination_iata: flights[departure][0].arrival_iata,
      };
      data.flights = flights[departure].map((e) => {
        if (data.lowest_price > e.price) {
          data.provider_permalink = e.provider_permalink;
          data.lowest_price = e.price;
        }
        return JSON.parse(JSON.stringify(e));
      });
      return data;
    })
    .filter((e) => e !== null);
  return tempDepartureData;
};

export default parseDepartureData;
